import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, FileTextIcon, CalculatorIcon, MessageCircleIcon } from 'lucide-react';
const benefits = [{
  icon: ShieldCheckIcon,
  title: 'Garantía de 5 años',
  text: 'Mayor tranquilidad después de terminado el trabajo.'
}, {
  icon: FileTextIcon,
  title: 'Contrato ante notaría',
  text: 'Respaldo formal para trabajar con más confianza.'
}, {
  icon: CalculatorIcon,
  title: 'Presupuesto gratis',
  text: 'Consulta tu proyecto y recibe orientación sin costo inicial.'
}, {
  icon: MessageCircleIcon,
  title: 'Contacto directo',
  text: 'Escríbenos por WhatsApp y cuéntanos qué necesitas construir o remodelar.'
}];
export function ValueProposition() {
  return <section className="py-20 bg-white" data-id="element-155">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-157">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-158">
            Trabajos de construcción con respaldo y compromiso real
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-gray-600 leading-relaxed" data-id="element-159">
            Con Mauricio Ramírez Construcciones, puedes solicitar un presupuesto
            gratis, revisar trabajos realizados y avanzar con mayor tranquilidad
            gracias a contratos ante notaría y garantía de 5 años después de la
            construcción.
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-160">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-concrete p-8 rounded-2xl hover:bg-navy hover:text-white transition-colors duration-300 group" data-id="element-161">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 text-orange group-hover:bg-white/10 group-hover:text-orange transition-colors" data-id="element-162">
                <benefit.icon className="w-7 h-7" data-id="element-163" />
              </div>
              <h3 className="text-xl font-bold text-navy group-hover:text-white mb-3 transition-colors" data-id="element-164">
                {benefit.title}
              </h3>
              <p className="text-gray-600 group-hover:text-gray-300 transition-colors" data-id="element-165">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}